var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Row',{staticClass:"dialog-header-container px-2 py-3 flex-align-center"},[_c('AppIcon',{staticClass:"mr-2",attrs:{"name":"upgrade-plan","width":18,"height":18}}),_c('h3',{staticClass:"reg"},[_vm._v(_vm._s(_vm.upgradeNeededExplanation))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }